import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import actions from './actions';
import getters from './getters';
import vuexI18n from 'vuex-i18n';
import mutations from './mutations';
import VuePaginate from 'vue-paginate';
import langEN from '../util/translations/lang_en';
import langCN from '../util/translations/lang_cn';
import langJA from '../util/translations/lang_ja';
import langKR from '../util/translations/lang_kr';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations
});

// Locale module
Vue.use(vuexI18n.plugin, store);

// Register locale files
Vue.i18n.add('en', langEN);
Vue.i18n.add('cn', langCN);
Vue.i18n.add('ja', langJA);
Vue.i18n.add('kr', langKR);

// Set default
Vue.i18n.set('en');

Vue.use(VuePaginate);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js